<template>
  <ErrorModal />
  <SaveSearch v-if="showSave === true" :showSave="showSave" />
  <SharePage />
  <DownloadPage />

  <div class="spinner-page" v-if="isPageLoading || isSideBarLoading">
    <q-spinner class="spinner" color="primary" size="3em" />
  </div>
  <div
    v-else
    class="grants-container"
    :class="isContrast != 'false' && isContrast != false ? 'high-contrast' : ''"
  >
    <div class="row justify-end" v-if="isVind">
      <q-btn class="onboarding-icon" no-caps @click="startTour()"
        >Start tour</q-btn
      >
    </div>

    <div class="row justify-between heading-container">
      <span class="main-heading">Subsidies zoeken</span>
      <div v-if="isDisplayDownloadMessage" class="download-finished row">
        <i class="las la-2x la-check-circle"></i>
        <span class="download-text">
          Download geslaagd
        </span>
      </div>
    </div>
    <div class="grants-search-main">
      <SideBarSearch ref="sideBar" />
      <div class="grant-cards-container">
        <div class="pagination top-pag">
          <q-pagination
            class="pagination-item"
            v-model="currentPage"
            color="black"
            outline
            direction-links
            :max="maxPages"
            :max-pages="6"
            boundary-numbers
            @click="goToPage(currentPage)"
          ></q-pagination>
        </div>

        <SearchBar id="v-step-1" />

        <div class="row float-end justify-end" v-if="isVind">
          <div
            class="offset-8 col-2 offset-md-6 col-md-3 offset-sm-8 col-sm-4"
          ></div>
          <div class="col-2 col-md-3 col-sm-4">
            <q-btn
              class="save-btn savesearch-btn outline flat"
              @click="enableSave()"
              id="v-step-12"
            >
              <i class="las la-2x la-save action-icon"> </i>
              Zoekactie opslaan
            </q-btn>
          </div>
        </div>

        <div class="icons-and-sorting">
          <div class="row justify-between q-mt-md">
            <div class="row icons-row-main">
              <div class="column action-icons-column">
                <div class="results-info column">
                  <span class="results-item"
                    >Pagina {{ currentPage }} van de {{ maxPages }}</span
                  >
                </div>

                <div class="row icons-list" v-if="isVind">
                  <i
                    class="las la-2x la-save action-icon"
                    @click="enableSaveScheme"
                    id="v-step-4"
                  >
                    <q-tooltip> Opslaan </q-tooltip></i
                  >
                  <i
                    class="las la-2x la-share action-icon q-ml-sm"
                    @click="sharePage()"
                    id="v-step-5"
                  >
                    <q-tooltip> Delen </q-tooltip></i
                  >
                  <i
                    class="las la-2x la-download action-icon q-ml-sm"
                    @click="downloadPage()"
                    id="v-step-6"
                  >
                    <q-tooltip> Downloaden </q-tooltip></i
                  >
                </div>
              </div>
              <ShareScheme v-if="isVind" />
              <SaveScheme v-if="isVind" />
              <DownloadScheme v-if="isVind" />
              <div class="dropdown-container" v-if="isVind">
                <q-btn-dropdown
                  outline
                  flat
                  label="Regelingen selecteren"
                  class="arrangements-dropdown-q"
                >
                  <div class="dropdown-heading q-pl-md q-pt-sm"></div>
                  <q-list>
                    <q-item
                      v-if="numberOfResultsOnPage != numberOfSelectedResults"
                      clickable
                      v-close-popup
                      @click="selectAllFromThisPage()"
                    >
                      <q-item-section>
                        <q-item-label
                          >Selecteer alles op deze pagina</q-item-label
                        >
                      </q-item-section>
                    </q-item>

                    <q-item
                      v-if="numberOfSelectedResults > 0"
                      clickable
                      v-close-popup
                      @click="deslectAllFromThisPage()"
                    >
                      <q-item-section>
                        <q-item-label>Wis selectie op deze pagina</q-item-label>
                      </q-item-section>
                    </q-item>
                  </q-list>
                </q-btn-dropdown>

                <q-btn
                  v-if="numberOfSelectedResults > 0"
                  flat
                  class="counter-btn"
                  >Geselecteerd: {{ numberOfSelectedResults }}</q-btn
                >
              </div>
            </div>

            <div class="sort-dropdown">
              <div class="row">
                <p class="sort-heading q-mt-sm">Sorteer op:</p>
                <q-select
                  class="sort-select"
                  dense
                  v-model="selectedSort"
                  input-debounce="0"
                  :options="sortOptions"
                  behavior="menu"
                  bg-color="white"
                  outlined
                />
              </div>
            </div>
          </div>
        </div>

        <div v-if="grants.length == 0 && isTourActive" class="q-mt-lg">
          <GrantCard
            :title="'Subsidieregeling praktijkleren'"
            :id="1000"
            :introduction="dummyGrant.introduction"
            :class="card"
            :grant="dummyGrant"
            class="v-step-2"
            :isDummy="true"
          />
        </div>

        <div
          class="cards"
          :class="areFiltersChanged ? 'opacity-low' : 'opacity-normal'"
        >
          <GrantCard
            v-for="(grant, idx) in grants"
            :key="grant.id"
            :title="grant.name"
            :grant="grant"
            :id="grant.id"
            :introduction="grant.introduction"
            class="card"
            :class="{ 'v-step-2': idx == 0 }"
            :matchingPercentage="getSchemeMatchingPercentage(grant.score)"
          />
          <div class="pagination">
            <q-pagination
              class="pagination-item"
              v-model="currentPage"
              color="black"
              outline
              :max="maxPages"
              direction-links
              :max-pages="6"
              boundary-numbers
              @click="goToPage(currentPage)"
            ></q-pagination>
          </div>
        </div>
      </div>
      <q-dialog v-model="showWarning">
        <q-card>
          <q-card-section class="row items-center">
            <i class="las la-2x la-exclamation-circle"></i>
            <span class="q-ml-sm"> Selecteer minstens één item </span>
          </q-card-section>

          <q-card-actions align="right">
            <q-btn outline label="Ok" color="primary" v-close-popup />
          </q-card-actions>
        </q-card>
      </q-dialog>

      <q-dialog v-model="showSavedInfoDialog">
        <q-card>
          <q-card-section class="row items-center">
            <i class="las la-2x la-info-circle"></i>
            <span class="q-ml-sm">
              Item is opgeslagen. Je vindt deze in &nbsp; </span
            ><a href="/profile/savedItems">opgeslagen items</a>
          </q-card-section>
          <q-card-section>
            <q-toggle
              v-model="receiveAlertForSavedItems"
              label="Wilt u alerts ontvangen voor deze opgeslagen items?"
            />
          </q-card-section>

          <q-card-actions align="right">
            <q-btn
              outline
              label="Ok"
              color="primary"
              @click="disableShowSavedInfoDialog()"
            />
          </q-card-actions>
        </q-card>
      </q-dialog>

      <q-dialog v-model="showSavedSearchInfoDialog">
        <q-card>
          <q-card-section class="row items-center">
            <i class="las la-2x la-info-circle"></i>
            <span class="q-ml-sm">
              Je zoekactie is opgeslagen. Je vindt deze in &nbsp; </span
            ><a href="/profile/savedItems">opgeslagen items</a>
          </q-card-section>
          <q-card-section>
            <q-toggle
              v-model="receiveAlertForSavedSearch"
              label="Wilt u alerts ontvangen voor deze zoekopdracht?"
            />
          </q-card-section>

          <q-card-actions align="right">
            <q-btn
              outline
              label="Ok"
              color="primary"
              @click="disableShowSavedSearchInfoDialog()"
            />
          </q-card-actions>
        </q-card>
      </q-dialog>

      <q-dialog v-model="showHiddenInfoDialog">
        <q-card>
          <q-card-section class="row items-center">
            <i class="las la-2x la-info-circle"></i>
            <span class="q-ml-sm">
              Verborgen items kun je vinden en terugzetten in je &nbsp; </span
            ><a href="/profile/hiddenSchemes">profiel</a>
          </q-card-section>
          <q-card-section>
            <q-checkbox
              dense
              size="sm"
              v-model="hideHiddenItemsDialog"
              label="Toon deze melding niet nog een keer"
              class="checkbox"
            />
          </q-card-section>

          <q-card-actions align="right">
            <q-btn
              outline
              label="Ok"
              color="primary"
              @click="disableShowHiddenInfoDialog()"
            />
          </q-card-actions>
        </q-card>
      </q-dialog>
    </div>
    <div class="circle-container">
      <div id="pagetop" class="top-scroll" v-if="scY > 300">
        <i class="las la-2x la-angle-up up-icon" @click="toTop">
          <q-tooltip self="center left" :offset="[10, 10]"
            >Naar boven</q-tooltip
          >
        </i>
      </div>
    </div>
  </div>
  <v-tour name="myTour" ref="tour" :steps="steps"></v-tour>
</template>

<script>
import GrantCard from '../components/GrantCard.vue';
import SideBarSearch from '../components/search-components/SidebarSearch.vue';
import { mapGetters, mapState } from 'vuex';
import { onMounted, computed, ref, watch } from 'vue';
import store from '../store/index.js';
import router from '@/router';
import GrantsService from '../services/grants.service';
import SearchBar from '../components/search-components/SearchBar.vue';
import SaveSearch from '../components/search-components/SaveSearch.vue';
import ErrorModal from '../components/userProfile-components/ErrorModal.vue';
import ShareScheme from '../components/share-components/ShareScheme.vue';
import SaveScheme from '../components/SaveScheme.vue';
import SharePage from '../components/share-components/SharePage.vue';
import FiltersService from '../services/filters.service';
import SchemeUtils from '../utils/schemes';
import DownloadPage from '../components/share-components/DownloadPage.vue';
import DownloadScheme from '../components/share-components/DownloadScheme.vue';
import UserService from '../services/userprofile.service';
export default {
  name: 'SearchGrants',
  components: {
    GrantCard,
    SideBarSearch,
    SearchBar,
    SaveSearch,
    ErrorModal,
    ShareScheme,
    SaveScheme,
    SharePage,
    DownloadPage,
    DownloadScheme,
  },

  setup() {
    const isApplyingFilters = computed({
      get: () => store.state.user.isApplyingFilters,
    });

    onMounted(async () => {
      UserService.getProfileConfiguration();
      UserService.getFavoriteAudienceTags();
      UserService.getFavoritePurposesTags();
      //This is just hidden for now, don't remove it:
      //UserService.getFavoriteIndustriesTags();
      UserService.getFavoriteLocationsTags();
      FiltersService.getDefaultFilters();
      store.commit('advancedSearch/createStatusesString');
      await SchemeUtils.searchSchemes();
      window.addEventListener('scroll', handleScroll);
      window.scrollTo(0, 0);
    });

    const sortOptions = ['Datum', 'Relevantie', 'Scope'];

    const selectedSort = computed({
      get: () => store.state.advancedSearch.selectedSort,
      set: async (value) => {
        store.commit('advancedSearch/updateSelectedSort', value);
        await SchemeUtils.searchSchemes();
      },
    });

    const showWarning = ref(false);

    const maxScoreOnCurrentPage = computed({
      get: () => store.state.advancedSearch.maxScoreOnCurrentPage,
    });

    const maxScore = computed({
      get: () => store.state.advancedSearch.maxScore,
    });

    // const getSchemeMatchingPercentage = (schemeScore) => {
    //   var percentage = (schemeScore * 100) / maxScoreOnCurrentPage.value;
    //   return percentage.toFixed();
    // };

    const getSchemeMatchingPercentage = (schemeScore) => {
      var percentage = (schemeScore * 100) / maxScore.value;
      return percentage.toFixed();
    };

    const maxPages = computed({
      get: () => store.state.advancedSearch.pageCount,
    });

    const grants = computed({
      get: () => store.state.grantItems.grants,
    });

    const shortDesc = computed({
      get: () => store.state.grantItems.grants.description,
    });

    const pagesCount = computed({
      get: () => store.state.grantItems.grants.totalRecords,
    });

    const resultsCount = computed({
      get: () => store.state.advancedSearch.numberOfResults,
    });

    const logStatus = computed({
      get: () => store.state.user.isLoggedIn,
    });

    const searchText = computed({
      get: () => store.state.advancedSearch.searchText,
    });

    const statuses = computed({
      get: () => store.state.advancedSearch.statusesString,
    });

    const audiences = computed({
      get: () => store.state.advancedSearch.selectedAudiences,
    });
    const locations = computed({
      get: () => store.state.advancedSearch.selectedLocations,
    });
    //This is just hidden for now, don't remove it:
    /*
    const industries = computed({
      get: () => store.state.advancedSearch.selectedIndustries,
    });
    */
    const purposes = computed({
      get: () => store.state.advancedSearch.selectedPurposes,
    });
    const schemeTypes = computed({
      get: () => store.state.advancedSearch.selectedSchemeTypes,
    });
    const projectTypes = computed({
      get: () => store.state.advancedSearch.selectedProjectTypes,
    });

    const smeString = computed({
      get: () => store.state.advancedFilters.smeString,
    });
    const applicationTermsString = computed({
      get: () => store.state.advancedFilters.termsString,
    });
    const minBudget = computed({
      get: () => store.state.advancedSearch.minBudget,
    });

    const maxBudget = computed({
      get: () => store.state.advancedSearch.maxBudget,
    });

    const scopesString = computed({
      get: () => store.state.advancedFilters.scopesString,
    });

    const startDate = computed({
      get: () => store.state.advancedSearch.startDate,
    });

    const endDate = computed({
      get: () => store.state.advancedSearch.endDate,
    });
    const orgsIncludeString = computed({
      get: () => store.state.advancedSearch.organisationsIncludeString,
    });

    const orgsExcludeString = computed({
      get: () => store.state.advancedSearch.organisationsExcludeString,
    });

    const activeFiltersCount = computed({
      get: () => store.state.advancedSearch.activeFiltersCount,
    });

    const enableSave = () => {
      store.commit('user/enableSave');
    };

    const enableSaveScheme = () => {
      if (numberOfSelectedResults.value > 0) {
        UserService.getFolders();
        store.commit('user/enableSaveScheme');
      } else showWarning.value = true;
    };

    const showSave = computed({
      get: () => store.state.user.showSave,
    });

    const receiveAlertForSavedSearch = computed({
      get: () => store.state.user.receiveAlertForSavedSearch,
      set: (val) => {
        store.commit('user/setReceiveAlertForSavedSearch', val);

        UserService.updateFolderItemAlert(savedSearchFolderItemId.value, val);
      },
    });

    const receiveAlertForSavedItems = computed({
      get: () => store.state.user.receiveAlertForSavedItems,
      set: (val) => {
        store.commit('user/setReceiveAlertForSavedItems', val);

        UserService.updateFolderItemsAlert(
          savedSchemesFolderItemsIds.value,
          val
        );
      },
    });

    const savedSearchFolderItemId = computed({
      get: () => store.state.user.savedSearchFolderItemId,
    });

    const savedSchemesFolderItemsIds = computed({
      get: () => store.state.user.savedSchemesFolderItemsIds,
    });

    const goToPage = async (currentPage) => {
      store.commit('advancedSearch/updateCurrentPage', currentPage);
      store.commit('advancedFilters/createTermsString');
      store.commit('advancedFilters/createSMEString');
      store.commit('advancedFilters/createScopesString');
      await GrantsService.getResulstsByPage(
        currentPage - 1,
        searchText,
        statuses,
        audiences,
        locations,
        //This is just hidden for now, don't remove it:
        //industries,
        purposes,
        schemeTypes,
        projectTypes,
        smeString,
        applicationTermsString,
        minBudget,
        maxBudget,
        scopesString,
        orgsIncludeString,
        orgsExcludeString,
        startDate,
        endDate,
        selectedSort
      );
      window.scrollTo(0, 0);
    };

    const currentPage = computed({
      get: () => store.state.advancedSearch.currentPage,
      set: (value) => store.commit('advancedSearch/updateCurrentPage', value),
    });

    const scTimer = ref(0);
    const scY = ref(0);
    const handleScroll = () => {
      if (scTimer.value) return;
      scTimer.value = setTimeout(() => {
        scY.value = window.scrollY;
        clearTimeout(scTimer.value);
        scTimer.value = 0;
      }, 100);
    };

    const toTop = () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    };

    const selectAllFromThisPage = () => {
      store.commit('grantItems/selectAllFromPage');
    };

    const deslectAllFromThisPage = () => {
      store.commit('grantItems/deselectAllFromPage');
    };

    const numberOfSelectedResults = computed({
      get: () => store.state.grantItems.selectedResultsCount,
    });

    const resultsSelectedLabel = ref(
      'Regelingen selecteren ' +
        (numberOfSelectedResults.value > 0
          ? '(' + numberOfSelectedResults.value + ')'
          : '')
    );

    watch(numberOfSelectedResults, () => {
      resultsSelectedLabel.value =
        'Regelingen selecteren ' +
        (numberOfSelectedResults.value > 0
          ? '(' + numberOfSelectedResults.value + ')'
          : '');
    });

    const sharePage = () => {
      if (numberOfSelectedResults.value > 0) {
        store.commit('grantItems/enableShareGrantsPage');
      } else showWarning.value = true;
    };

    const downloadPage = () => {
      if (numberOfSelectedResults.value > 0) {
        store.commit('grantItems/enableDownloadSchemesPage');
      } else showWarning.value = true;
    };

    const isPageLoading = computed({
      get: () => store.state.grantItems.isSearchPageLoading,
    });

    const isSideBarLoading = computed({
      get: () => store.state.grantItems.isSideBarLoading,
    });

    const numberOfResultsOnPage = computed({
      get: () => store.state.grantItems.grants.length,
    });

    const sideBar = ref(null);

    const resetSearch = (isClear) => {
      sideBar.value.resetSearch(isClear);
    };

    const activeFiltersLabel = ref(
      'Actieve filters: ' + activeFiltersCount.value
    );

    watch(activeFiltersCount, () => {
      activeFiltersLabel.value = 'Actieve filters: ' + activeFiltersCount.value;
    });

    const refreshTrees = () => {
      sideBar.value.refreshTrees();
    };

    const applyProfileFilters = () => {
      store.commit(
        'advancedSearch/updateSelectedAudiences',
        store.state.user.favoriteAudiencesIdsArray
      );
      //This is just hidden for now, don't remove it:
      /*
      store.commit(
        'advancedSearch/updateSelectedIndustries',
        store.state.user.favoriteIndustriesIdsArray
      );
      */
      store.commit(
        'advancedSearch/updateSelectedPurposes',
        store.state.user.favoritePurposesIdsArray
      );
      store.commit(
        'advancedSearch/updateSelectedLocations',
        store.state.user.selectedFavoriteLocations
      );

      refreshTrees();
    };

    const showSavedInfoDialog = computed({
      get: () => store.state.user.showSavedInfoDialog,
    });

    const showSavedSearchInfoDialog = computed({
      get: () => store.state.user.showSavedSearchInfoDialog,
    });

    const disableShowSavedInfoDialog = () => {
      store.commit('user/disableShowSavedInfoDialog');
    };

    const disableShowSavedSearchInfoDialog = () => {
      store.commit('user/disableShowSavedSearchInfoDialog');
    };

    const showHiddenInfoDialog = computed({
      get: () => store.state.user.showHiddenInfoDialog,
    });

    const hideHiddenItemsDialog = computed({
      get: () => store.state.user.hideHiddenItemsDialog,
      set: (value) => {
        store.commit('user/updateHideHiddenItemsDialog', value);
        UserService.setHideHiddenItemsDialog(value);
      },
    });

    const disableShowHiddenInfoDialog = () => {
      store.commit('user/disableShowHiddenInfoDialog');
    };

    const isProfileSearch = computed({
      get: () => store.state.user.isProfileSearch,
    });

    const areFiltersChanged = computed({
      get: () => store.state.advancedSearch.areFiltersChanged,
    });

    const steps = [
      {
        target: '#v-step-0', // We're using document.querySelector() under the hood
        offset: -3000,

        content: `Gebruik de filters om uw zoekresultaat te verbeteren. Wanneer je filters activeert/de-activeert zullen de zoekresultaten direct worden aangepast`,
      },
      {
        target: '#v-step-1',
        offset: -600,

        content: 'Vul zoekwoorden in om resultaten verder te verfijnen',
      },
      {
        target: '.v-step-2',
        offset: -800,

        content: `Voor elk gevonden resultaat wordt algemene informatie getoond, het type vermelding en de verstrekker zien. Aankomende deadlines of nieuw vermelde items worden ook gemarkeerd.<br> Klik op de titel van het resultaat om meer details te zien. Kies in de instellingen of de details op dezelfde pagina worden geopend of in een nieuwe tab </br>`,
      },
      {
        target: '#v-step-3', // We're using document.querySelector() under the hood
        offset: -800,

        content: `Gebruik deze slider om meerdere regelingen te selecteren`,

        params: {
          placement: 'top',
        },
      },
      {
        target: '#v-step-4',
        offset: -800,

        content:
          'Sla de geselecteerde regelingen op. Deze worden opgeslagen in ‘Opgeslagen items’',
      },
      {
        target: '#v-step-5',
        offset: -800,

        content:
          'Deel de geselecteerde regelingen via een emailbericht. De geselecteerde regelingen worden hiervoor verzameld in een rapport',
      },
      {
        target: '#v-step-6',
        offset: -800,

        content:
          'Download de geselecteerde regelingen in een automatisch gegenereerd rapport',
      },
      {
        target: '#v-step-7',
        offset: -800,
  
        content:
          'Sla dit resultaat op om hem later gemakkelijk terug te vinden',
      },

      {
        target: '#v-step-8',
        offset: -800,

        content: 'Verberg het resultaat uit deze en toekomstige zoekacties',
      },
      {
        target: '#v-step-9',
        offset: -800,

        content: 'Deel dit resultaat via een emailbericht',
      },
      {
        target: '#v-step-10',
        offset: -800,

        content:
          'Download dit resultaat in een automatisch gegenereerd rapport',
      },
      {
        target: '#v-step-11',
        offset: -800,

        content:
          'Gebruik deze slider om de filters uit je profiel toe te passen op je zoekactie',
      },
      {
        target: '#v-step-12',
        offset: -800,

        content:
          'Sla je zoekactie op en stel wanneer gewenst notificaties daarop in',
      },
      {
        target: '#v-step-13',
        offset: -800,

        content:
          'Hier stel je je profiel in, verander je je nieuwsbrief voorkeuren en vind je opgeslagen en verborgen items',
      },
    ];

    const tour = ref(null);
    const startTour = () => {
      tour.value.customOptions.labels.buttonNext = 'Volgende';
      tour.value.customOptions.labels.buttonPrevious = 'Vorige';
      tour.value.customOptions.labels.buttonStop = 'Klaar';
      tour.value.customOptions.labels.buttonSkip = 'Rondleiding beëindigen';

      tour.value.callbacks.onStart = () => {
        store.commit('user/updateIsTourActive', true);
      };
      tour.value.callbacks.onSkip = () => {
        store.commit('user/updateIsTourActive', false);
      };
      tour.value.callbacks.onStop = () => {
        store.commit('user/updateIsTourActive', false);
      };
      tour.value.callbacks.onFinish = () => {
        store.commit('user/updateIsTourActive', false);
      };
      tour.value.start();
    };

    const isTourActive = computed({
      get: () => store.state.user.isTourActive,
    });

    const dummyGrant = {
      id: '100515',
      idoxKey: 'S10706',
      identifier: null,
      itemType: 0,
      smeType: 'NotSME',
      score: 2,
      name: 'Subsidieregeling praktijkleren',
      introduction:
        'Het doel van de Subsidieregeling praktijkleren (PRAKTIJKLEREN) is het stimuleren van werkgevers om praktijkleerplaatsen en werkleerplaatsen aan te bieden.',
      body:
        '<p>Het doel van het A&amp;O Fonds Grafimediabranche (AOFG) is het bevorderen van opleidingen en de arbeidsmarkt in de grafimediabranche.\n<br />\n<br />Werkgevers en werknemers die lid zijn van het A&amp;O Fonds Grafimediabranche komen in aanmerking voor subsidie.\n<br />\n<br />Het fonds beschikt over de volgende subsidieregelingen:</p>\n<ul>\n    <li>Stimuleringsregeling BBL;</li>\n    <li>Subsidieregeling opleidingen machineleveranciers;</li>\n    <li>Subsidieregeling printmedia opleidingen;</li>\n    <li>Subsidieregeling uitzendkrachten;</li>\n    <li>Subsidieregeling voor begeleidingstaken praktijkopleiders;</li>\n    <li>Subsidieregeling voor financieel adviesgesprek;</li>\n    <li>Tijdelijke subsidieregeling van-werk-naar werk trajecten/mobiliteitsprojecten.</li>\n</ul>\n<p>\n<br />De voorwaarden en de hoogte van de bijdrage verschillen per regeling.\n<br />\n<br />Aanvragen kunnen worden ingediend bij het A&amp;O Fonds Grafimediabranche.</p>',
      criteria: null,
      accronym: 'AOFG',
      organisations: [
        {
          id: '156115',
          value: 'Ministerie van Onderwijs, Cultuur en Wetenschap (OCW)',
        },
      ],
      status: 'Aangekondigd',
      publicationStatus: 'Live',
      scope: 'Undefined',
      applicationTerm: 'Undefined',
      link: '',
      periodTitle: null,
      periodDescription: null,
      calls: [],
      minAmount: 3015.0,
      maxAmount: 'Onbepaald',
      createdDate: '22-02-06T00:00:00',
      updatedDate: '2022-02-17T13:53:26.7855733',
      currentDeadline: null,
      schemeStart: null,
      schemeEnd: null,
      callStart: null,
      callEnd: null,
      currentDeadlineHeaderText: 'Openstelling',
      currentDeadlineText: 'Onbepaald',
      callCount: 0,
    };

    const isVind = computed({
      get: () => store.state.auth.env === 0 || store.state.auth.env === 40,
    });

    const isContrast = computed({
      get: () => store.state.user.isSelectedThemeContrast,
    });

    const isDisplayDownloadMessage = computed({
      get: () => store.state.grantItems.isDisplayDownloadMessage,
    });

    return {
      isDisplayDownloadMessage,
      isContrast,
      isVind,
      dummyGrant,
      isTourActive,
      steps,
      tour,
      startTour,
      areFiltersChanged,
      isApplyingFilters,
      isProfileSearch,
      showSavedInfoDialog,
      showSavedSearchInfoDialog,
      showHiddenInfoDialog,
      hideHiddenItemsDialog,
      disableShowSavedInfoDialog,
      disableShowHiddenInfoDialog,
      disableShowSavedSearchInfoDialog,
      sideBar,
      activeFiltersLabel,
      resetSearch,
      isSideBarLoading,
      downloadPage,
      numberOfResultsOnPage,
      isPageLoading,
      sharePage,
      numberOfSelectedResults,
      resultsSelectedLabel,
      deslectAllFromThisPage,
      selectAllFromThisPage,
      activeFiltersCount,
      handleScroll,
      toTop,
      scTimer,
      scY,
      orgsIncludeString,
      orgsExcludeString,
      applicationTermsString,
      smeString,
      grants,
      shortDesc,
      pagesCount,
      resultsCount,
      router,
      minBudget,
      maxBudget,
      startDate,
      endDate,
      searchText,
      currentPage,
      logStatus,
      maxPages,
      statuses,
      schemeTypes,
      projectTypes,
      purposes,
      scopesString,
      //This is just hidden for now, don't remove it:
      //industries,
      audiences,
      locations,
      goToPage,
      enableSave,
      enableSaveScheme,
      showSave,
      selectedSort,
      sortOptions,
      showWarning,
      applyProfileFilters,
      refreshTrees,
      receiveAlertForSavedSearch,
      savedSearchFolderItemId,
      receiveAlertForSavedItems,
      savedSchemesFolderItemsIds,
      maxScoreOnCurrentPage,
      maxScore,
      getSchemeMatchingPercentage,
      computed: {
        ...mapState({
          showAdvancedSearch: (state) =>
            state.advancedSearch.showAdvancedSearch,
        }),
        ...mapGetters('advancedSearch', {
          showAdvancedSearch: 'showAdvancedSearch',
        }),
      },
    };
  },
};
</script>
